import GetHierarchyParams from './HierarchyParams';

const GetHierarchyBody = ({
  path,
  blocks,
  getMergedTemplate,
  currentOverrides,
  jsxComponents,
  sortComponents,
}) => {
  let { config: updatedConfig, path: updatedPath } = getMergedTemplate(path, currentOverrides);

  while (updatedConfig.path === 'LayoutItem') {
    const updatedValues = getMergedTemplate(updatedPath, currentOverrides);
    updatedConfig = updatedValues.config;
    updatedPath = updatedValues.path;
  }

  const componentMetaData = jsxComponents.find(({ name }) => name === updatedConfig.path);

  if (!componentMetaData) {
    return null;
  }

  return GetHierarchyParams({
    componentMetaData,
    layoutItem: updatedConfig,
    path: updatedPath,
    sortComponents,
    blocks,
    getMergedTemplate,
    currentOverrides,
    jsxComponents,
  });
};

export default GetHierarchyBody;